<div *ngIf="event" class="col-xs-12 col-md-12" id="reservation-wrapper">
  <div class="card" *ngIf="isEnd">
    <div class="card-header">
      <header>{{'front_event.closed'| translate}}</header>
    </div>
    <div class="card-body p-2">
      {{'front_event.this_event_is_end'| translate}}
    </div>
  </div>
  <!--<div class="card" *ngIf="!isEnd && event.has_ticketing=='0' && event.has_open_ticketing=='0'  ">
    <div class="card-header">
      <header>{{'front_event.no_booking'| translate}}</header>
    </div>
    <div class="card-body p-2">
      {{'front_event.this_event_has_no_ticketing'| translate}}
    </div>
  </div>-->
  <!-- TODO #MEDIUM prevoir un affichage qd toutes les places completes -->
  <div class="card" *ngIf="!isEnd && event_has_Booking(event) && isClosed">
    <div class="card-header">
      <header> {{'front_event.booking_is_end'| translate}}</header>
    </div>
    <div class="card-body p-2">
      {{'front_event.it_is_no_longer_possible_to_book_this_event'| translate}}
    </div>
  </div>
  <div class="card event-reservation" [ngClass]="isDraftCls()" *ngIf="!isEnd && event_has_Booking(event) && !isClosed">
    <div class="card-header">
      <header *ngIf="!eventIsjackpot(event)">{{'front_event.book'| translate}}</header>
      <header *ngIf="eventIsjackpot(event)">{{'front_event.participate'| translate}}</header>
    </div>
    <div class="card-body">
      <!--<div class="counter-wrapper" *ngIf="!countdownStoped && !event.has_open_ticketing">
        <ul id="counter" class="flexible">
          <li>
            <input type="text" disabled name="days" value="{{diffdays}}">
            <label  class="text-uppercase">{{'front_event.days'| translate}}</label>
          </li>
          <li>
            &lt;!&ndash; <countdown [text]="text" units="Hours"  end="July 22, 2019"></countdown>&ndash;&gt;
            <input type="text" disabled name="hours" value="{{diffhour}}">
            <label  class="text-uppercase">{{'front_event.hours'| translate}}</label>
          </li>
          <li>
            &lt;!&ndash;  <countdown [text]="text" units="Minutes"  end="July 22, 2019"></countdown>&ndash;&gt;
            <input type="text" disabled name="minutes" value="{{diffminutes}}">
            <label  class="text-uppercase">{{'front_event.minutes'| translate}}</label>
          </li>
        </ul>
      </div>-->

      <div *ngIf="event_has_Booking(event)" style="text-align: center!important;">

        <div *ngIf="event.has_open_ticketing && !startJackpot" class="center">
          <div class="center " style="margin-bottom: 2px;margin-top: 10px">
            <div class="bold fontsize-40 line-heih-38" style="margin-bottom: 5px">{{showValue(event.objectiveState) +' '+functionUtils.getPricingDeviseSymbole(event.currency)}}</div>

            <span class="text-uppercase bold" *ngIf="event.showObjective">{{'front_event.COLLECTED_ON'| translate}} {{showValue(event.objective) +' '+functionUtils.getPricingDeviseSymbole(event.currency) }}</span>
            <span class="text-uppercase bold" *ngIf="!event.showObjective">{{'front_event.collected'| translate}}</span>

          </div>
          <div class="progress progress-custom"  *ngIf="event.showObjective == 1">
            <div class="progress-bar" [ngStyle]="{'width': objectiveRate + '%'}" role="progressbar"  attr.aria-valuenow="{{objectiveRate}}" aria-valuemin="0" aria-valuemax="100"></div>
          </div>

          <div class="flexible space-between pading-responsive-left-22-right-28" style="margin-top: 15px">

            <div class="">
                    <span  class="font-size-20 center">  <i class="fa fa-clock-o" aria-hidden="true"></i>{{jackpotdaysremain}}<br>
                    <span>
                      {{'front_event.Remaining_days'| translate}}
                    </span>
                    </span>
            </div>

            <div class="margin-left-41-responsive">
                    <span class="font-size-20 center">
                    {{event.orders.length}} <i class="fa fa-user"></i> <br> Participations
                   </span>
            </div>

          </div>
        </div>

        <ng-container *ngIf="!event.has_open_ticketing || startJackpot">


          <div *ngFor="let group of pricingGroups">
            <div *ngIf="group.pricings.length">
              <a style="display: inline-block" attr.aria-expanded="{{group.is_open?'true':'false'}}" data-toggle="collapse"  href="#collapse{{group.id}}" class="classCollapse" >{{group.label}}</a>

              <div class="collapse bg-white {{group.is_open?'show pricing-group-is-open':''}}"  id="collapse{{group.id}}">
                <div  *ngFor="let pricing of group.pricings" >
                  <div class={{checkExhausted(pricing)}}>
                    <app-pricing-header [pricing]="pricing" [isFrame]="isFrame" [front_event]="front_event"></app-pricing-header>
                    <div   class="price-wrapper" [ngClass]="{'alert alert-danger': (pricing.Totalplace < pricing.nbreTicket)&& (pricing.Totalplace != -1)}">
                      <!--pas de cagnote ,normal-->
                      <span  class="price {{pricing.codePromo?'linet':''}}" *ngIf="!pricing.open">{{price(getPricingPrice(pricing))}}</span>
                      <span  class="price " *ngIf="pricing.codePromo">{{ price(calculatePricingPriceAfterPromoApply(pricing))}}</span>

                      <!--si cagnote-->
                      <!--  [ngClass]="{'alert alert-danger': (getPricingPrice(pricing)<1)}"-->

                      <span class="{{event.currency === 'USD'?'input-symbol-dollar':'input-symbol-euro'}} input-symbol-currency" *ngIf="pricing.open">
                          <input  *ngIf="pricing.open && !pricing.IsClosed"  (change)="changeListener($event,pricingsAndPrincingsInGroup)" min="1" style="display: inline-block" class="form-control pricing-selection" [(ngModel)]="pricing.price"  type="number">
                        </span>

                      <select class="pricing-selection {{pricing.open?'hide':''}} " *ngIf="!(pricing.Totalplace <= 0 && pricing.Totalplace != -1 && pricing.ShowNbPlace) && !pricing.IsComing && !pricing.IsClosed" type="number" [(ngModel)]="pricing.nbreTicket" value="{{pricing.nbreTicket}}" min="0"  (change)="changeListener($event,pricingsAndPrincingsInGroup)" name="nbreTicket" >

                        <ng-container *ngIf="!pricing.selectable_q">
                          <option  *ngFor = 'let item of nbTicketArray' value="{{ item }}" >{{ item}}</option>
                        </ng-container>

                        <ng-container *ngIf="pricing.selectable_q">
                          <option  *ngFor = 'let item of  pricing.pricingSelectableArray' value="{{ item }}" >{{ item}}</option>
                        </ng-container>

                      </select>

                      <app-pricing-statut [pricing]="pricing"></app-pricing-statut>
                    </div>
                  </div>
                  <div class="pricing-desc collapse" id="collapse{{pricing.id}}">
                    <span>{{nbPlace(pricing)}}</span>
                    <span [innerHTML]="pricing.description">{{pricing.description}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div  *ngFor="let pricing of pricings">
            <div class="{{checkExhausted(pricing )}} {{pricing.open?'block-important':''}} {{pricing.open?'pading-0':''}}" style="padding-bottom: 1px!important;">

              <app-pricing-header [isFrame]="isFrame" class="{{pricing.open?'hide':''}}" [pricing]="pricing" [front_event]="front_event"></app-pricing-header>

              <!--si cagnote-->
              <div *ngIf="pricing.open">
                <div class="{{pricing.open?'block-important':'hide'}} center" style="font-size: 19px">
                  <span>  {{'front_event.Choose_the_amount_of_your_participation'| translate}} </span>
                </div>
                <div class="center" style="margin-bottom: 15px;margin-top: 40px">
                  <div *ngFor = 'let item of openPricePurpose' class="inline-block">
                    <div *ngIf="item.value" class="pricing-purpose-class {{item.active?'purpose-active':''}} pointer-t" (click)="purposeOpenprice(item,pricing)"><span> {{item.value}}</span></div>
                  </div>
                </div>
              </div>

              <div class="block-important center">
                <!-- "-->
                <span class="{{event.currency=='USD'?'input-symbol-dollar':'input-symbol-euro'}} input-symbol-currency" *ngIf="pricing.open">
                         <input  *ngIf="pricing.open && !pricing.IsClosed" placeholder="montant libre"  style="display: inline-block" (change)="changeopenPricingsListener($event,pricingsAndPrincingsInGroup)" class="form-control pricing-selection width-80" [(ngModel)]="pricing.price" value="{{pricing.price}}" type="number">
                     </span>
              </div>

              <div class="price-wrapper" [ngClass]="{'alert alert-danger': pricingIsToMuchSelected(pricing)}">
                <!--pas de cagnote ,normal-->
                <span class="price {{pricing.codePromo?'linet':''}}" *ngIf="!pricing.open">{{price(getPricingPrice(pricing))}}</span>

                <span class="price" *ngIf="pricing.codePromo">{{price(calculatePricingPriceAfterPromoApply(pricing))}}</span>

                <select class="pricing-selection {{pricing.open?'hide':''}} " *ngIf="!(pricing.Totalplace <= 0 && pricing.Totalplace != -1 && pricing.ShowNbPlace) && !pricing.IsComing && !pricing.IsClosed" type="number" [(ngModel)]="pricing.nbreTicket" value="{{pricing.nbreTicket}}" min="0"  (change)="changeListener($event,pricingsAndPrincingsInGroup)" name="nbreTicket" >

                  <ng-container *ngIf="!pricing.selectable_q">
                    <option  *ngFor = 'let item of nbTicketArray' value="{{ item }}" >{{ item}}</option>
                  </ng-container>

                  <ng-container *ngIf="pricing.selectable_q">
                    <option  *ngFor = 'let item of  pricing.pricingSelectableArray' value="{{ item }}" >{{ item}}</option>
                  </ng-container>

                </select>

                <app-pricing-statut [pricing]="pricing"></app-pricing-statut>
              </div>
            </div>
            <div class="pricing-desc collapse" id="collapse{{pricing.id}}">
              <span>{{nbPlace(pricing)}}</span>
              <span [innerHTML]="pricing.description">{{pricing.description}}</span>
            </div>
          </div>

          <div class="alert alert-success flexible space-between" *ngFor="let code of codePromosActivated">
            <div>
              <div>
                    <span>
                   {{code.name+' activé'}}
                      <i class="fa fa-arrow-right"></i>
                   <span *ngIf="code.pricing">{{': '+code.pricing.label}}</span>
                   <span *ngIf="code.reduction_simple"> {{'- '+code.reduction_simple+' '+functionUtils.getPricingDeviseSymbole(event.currency)+' TTC'}}</span></span>
                <span *ngIf="code.reduction_by_percentage"> {{'- '+code.reduction_by_percentage+' %'}}</span>
                <span *ngIf="code.reduction_type == 'Gratuit'"> Gratuit</span>
              </div>
              <span class="pointer1" (click)="deleteCodePRomo(code)">Supprimer</span>
            </div>
          </div>

          <div class="price-total"  *ngIf="event_has_Booking(event) && pricings">
            {{'front_event.total'| translate}}: <span class="price ">{{Total.toFixed(2) +' '+functionUtils.getPricingDeviseSymbole(devise)}}</span>
          </div>

          <div class="code-promo" *ngIf="!hasCodePromoClicked && event.codes.length > 0">
            Vous avez un code de réduction: <span class="click-here pointer1" (click)="changeHasCodePromo()">Cliquez ici</span>
          </div>

          <div class="code-promo" *ngIf="hasCodePromoClicked">
            <input class="form-control col-md-6 inline-block" [(ngModel)]="codePrmo"  placeholder="Entrer votre code"  type="text">  <span class="apply-code-btn pointer1" (click)="applycodePromo()">Appliquer</span>
          </div>
        </ng-container>
      </div>
    </div>
    <div *ngIf="event_has_Booking(event) && pricings" style="text-align: right;margin-right: 30px;">
      <a   title="Poursuivre" href="javascript:void(0);" (click)="poursuivre(pricings)" id="validateCmd" style="width: 143px!important;padding: 8px!important;font-size: unset!important;text-align: center" class="inline-block text-uppercase">
        {{'front_event.continue'| translate}}
      </a>
    </div>
    <div *ngIf="event_has_Booking(event) && pricings">
      <div class="text-center" style="margin-bottom: 20px">
        <div>
          <li class="list-inline-item">
            <img src="assets/imgs/payment/visa.png" class="img-fluid" width="70" alt="..."/>
          </li>
          <li class="list-inline-item">
            <img src="assets/imgs/payment/mastercard.png" class="img-fluid" width="70" alt="..."/>
          </li>
          <div class="payment-icon__right">
            <img src="assets/imgs/payment/badge_secu.png" class="img-fluid" width="125" alt="..."/>
          </div>
        </div>
        <div style="margin-top: 15px">Powered by akces</div>
      </div>
    </div>
  </div>
</div>
